enum AppFeature {
    OVERVIEW = 'overview',
    EXPLORE = 'explore',
    PLAN = 'plan',
    WALLET = 'wallet',
    NEWS = 'news',
}

export default AppFeature